module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "row main",
    class: {
      'slide-in-left': _vm.navbarShow
    }
  }, [_c('section', {
    staticClass: "col-2 is-scrollable navbar"
  }, [_c('navbar')], 1), _vm._v(" "), _c('section', {
    ref: "main",
    staticClass: "col-6 is-scrollable content",
    on: {
      "click": function($event) {
        _vm.navbarShow = false
      }
    }
  }, [_c('div', {
    staticClass: "navbar-toggle-container"
  }, [_c('button', {
    staticClass: "navbar-toggle",
    on: {
      "click": _vm.toggleNavbar
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('section', {
    staticClass: "col-4 demo"
  }, [_c('phone')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3456b5e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 62
// module chunks = 128